import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { PersonalIcon } from "components/icons";
import Image from "components/Image";
import ActionItem from "./ActionItem";

import { useAuthStore } from "@type/store";
import { logout } from "helpers/logout";
import { useOutsideClick } from "hooks/useOutsideClick";

const ProfileAction = () => {
  const refDiv = useRef(null);
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const [shadowOpenActionItem, setShadowOpenActionItem] = useState(false);
  const [openActionItem, setOpenActionItem] = useState(false);

  const handleOnOpenActionItem = () => {
    setShadowOpenActionItem((prev) => !prev);
  };

  const handleSwitchApp = () => {
    navigate("/landing");
  };

  useOutsideClick(refDiv, () => {
    setShadowOpenActionItem(false);
  });

  useEffect(() => {
    const timeout = setTimeout(
      () => {
        setOpenActionItem(shadowOpenActionItem);
      },
      shadowOpenActionItem ? 0 : 500
    );

    return () => {
      clearTimeout(timeout);
    };
  }, [shadowOpenActionItem]);

  return (
    <div ref={refDiv} className="w-auto z-[100]">
      <button
        onClick={handleOnOpenActionItem}
        className="cursor-pointer flex justify-center items-center w-[2.8rem] h-[2.8rem] rounded-full bg-primary-500"
      >
        <Image
          imageUrl={user.profilePicture}
          backgroundColor="#007AF5"
          label={
            <PersonalIcon
              width={20}
              height={20}
              viewBox="0.3 0 24 24"
              pathColor="#F5FAFF"
            />
          }
          width={35}
          height={35}
          className="flex items-center justify-center"
        />
      </button>

      {openActionItem && (
        <div className="absolute -ml-[14.5rem] mt-6">
          <ActionItem
            open={shadowOpenActionItem}
            onLogout={logout}
            onSwitchApp={handleSwitchApp}
          />
        </div>
      )}
    </div>
  );
};

export default ProfileAction;
